
import { SiriusBaseComponent } from 'sirius-framework';
import { CommonService } from '../../shared/service/shared.service';
import { SiteLanguageService } from '../../shared/service/site-language.service';
import { DocumentPopupService } from './documentPopup.service';
import { DocumentPopupModel } from './documentPopup.model';
import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

declare const $: any;

/** String resource — boşsa Türkçe varsayılan */
const DOCUMENT_POPUP_KEYS = {
    btnTamam: 'yediEminDocumentPopupBtnTamam',
    defaultTitle: 'yediEminDocumentPopupDefaultTitle',
};

const DOCUMENT_POPUP_DEFAULT_BTN = 'Tamam';
const DOCUMENT_POPUP_DEFAULT_TITLE = 'Belge';

@Component({
    selector: 'document-popup',
    templateUrl: './documentPopup.component.html',
    styleUrls: ['./documentPopup.component.css']
})

export class DocumentPopupComponent extends SiriusBaseComponent<DocumentPopupModel> implements OnDestroy {
    @Input() opened: boolean = false;
    @Input() visibleCancelBtn: boolean = true; 
    private _documentID: string; 
    @Input() set documentID(value: string) {
        this._documentID = value;
        setTimeout(() => {
            $('#backBtnControlC').trigger("click");
        }, 200);
    }
    @Output() onClose = new EventEmitter();
    @Output() onCancel = new EventEmitter();
    @Output() onScrollEnd = new EventEmitter();
    @Output() onOverlayClicked = new EventEmitter();

    isScrollEnd: boolean = false;
    /** Üst parent vermezse gösterilecek başlık yedeği */
    defaultDocumentTitle = 'Belge';
    @Input() title: string = '';
    btnTamam = 'Tamam';
    scrollTop: any;
    clientHeight: any;
    scrollHeight: any;
    isFirstCall: boolean = true;

    private langSub: Subscription;

    get documentID(): string {
        return this._documentID;

    }

    constructor(
        private service: DocumentPopupService,
        private commonService: CommonService,
        private siteLanguageService: SiteLanguageService,
    ) {
        super();
        this.langSub = this.siteLanguageService.languageCode$.subscribe(() => {
            this.loadDocumentPopupResourceStrings();
        });
    }

    ngOnDestroy() {
        if (this.langSub) {
            this.langSub.unsubscribe();
        }
    }

    onDocLoad() {
        $('#backBtnControlC').trigger("click"); 
    }

    OnInit() {
        $('html').addClass('dont-move-back');
    }

    private loadDocumentPopupResourceStrings(): void {
        const r = (key: string, fallback: string) => this.commonService.getStringResource(key, fallback);
        this.btnTamam = r(DOCUMENT_POPUP_KEYS.btnTamam, DOCUMENT_POPUP_DEFAULT_BTN);
        this.defaultDocumentTitle = r(DOCUMENT_POPUP_KEYS.defaultTitle, DOCUMENT_POPUP_DEFAULT_TITLE);
    }

    public close(e: any) {
        this.onClose.emit(e);
        $('html').removeClass('dont-move-back');
    }

    public open() {

    }

  scroll(e: Event) {
    //TODO Volkan: Kontrol et.
        var scrollTop = (e.srcElement as HTMLElement).scrollTop;
        var clientHeight = (e.srcElement as HTMLElement).clientHeight;
        var scrollHeight = (e.srcElement as HTMLElement).scrollHeight;

        //close ve cancel eventenden sonra tekrar çalışıyor.
        if ((scrollTop + clientHeight) >= scrollHeight && this.isFirstCall) {
            this.onScrollEnd.emit(this.title);
            this.isScrollEnd = true;
        }
        this.isFirstCall = true;
    }

    closeDocument() {
        //this.opened = false;
        $('html').removeClass('dont-move-back');
        //this.documentID = null;
        $('#docHolder').scrollTop(0);
        this.isScrollEnd = false;
        this.onClose.emit(this.title);
        this.isFirstCall = false;

    }

    cancelDocument() {
        //this.opened = false;
        $('html').removeClass('dont-move-back');
        //this.documentID = null;
        $('#docHolder').scrollTop(0);
        this.isScrollEnd = false;
        this.onCancel.emit(this.title);
        this.isFirstCall = false;
    }

    clickOverlay(e: Event) {
        this.onOverlayClicked.emit(this.title);
    }
}
